import Vue from 'vue'
import Vuex from 'vuex'
import menu from './modules/menu'
import permission from './modules/permission'
import viewRoute from './modules/viewRoute'
import getters from './getters'
import customerSearch from "./modules/customerSearch"
import logSearch from "./modules/logSearch"
import siteInfo from  "./modules/siteInfo"
import contractSearch from "./modules/contractSearch"
import adplayerSearch from "./modules/adplayerSearch";
import repaycontractSearch from "./modules/repaycontractSearch";
import repayindexSearch from "./modules/repayindexSearch";
import invoceSearch from "./modules/invoceSearch";

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    menu,
    permission,
    viewRoute,
    customerSearch,
    logSearch,
    siteInfo,
    contractSearch,
    adplayerSearch,
    repaycontractSearch,
    repayindexSearch,
    invoceSearch
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js